/* eslint-disable object-curly-newline */
export default {
  N_REQ: { level: 'N', charge: 'C', statusName: '요청', pay: '-', desc: '정기심사요청' },

  X_CAN: { level: 'X', charge: 'C', statusName: '취소', pay: '-', desc: '신청취소' },
  X_ABT: { level: 'X', charge: 'C', statusName: '중단', pay: '-', desc: '심사중단' },
  X_WDA: { level: 'X', charge: 'C', statusName: '철회', pay: '-', desc: '심사철회' },
  A_REQ: { level: 'A', charge: 'A', statusName: '접수', pay: '-', desc: '신청' },
  A_ACC: { level: 'A', charge: 'A', statusName: '검토', pay: '-', desc: '신청서검토' },
  A_APR: { level: 'A', charge: 'O', statusName: '승인', pay: '-', desc: '신청승인' },
  A_FER: { level: 'A', charge: 'C', statusName: '승인', pay: '미납', desc: '수수료입금대기' },
  A_FEC: { level: 'A', charge: 'O', statusName: '승인', pay: '입급확인요청', desc: '수수료입금확인대기' },
  A_FEA: { level: 'A', charge: 'A', statusName: '승인', pay: '입급확인완료', desc: '수수로입금확인' },
  A_CHA: { level: 'A', charge: 'A', statusName: '승인', pay: '-', desc: '기관변경 승인' },
  A_EXM: { level: 'A', charge: 'A', statusName: '면제', pay: '-', desc: '심사 면제' },
  A_REX: { level: 'A', charge: 'A', statusName: '접수', pay: '-', desc: '재심사 신청' },

  A_END: { level: 'A', charge: 'A', statusName: '승인', pay: '-', desc: '신청접수단계로 이동' },

  P_RDY: { level: 'P', charge: 'A', statusName: '접수', pay: '-', desc: '심사준비' },
  P_CJD: { level: 'P', charge: 'A', statusName: '진행중', pay: '-', desc: '심사원선정완료' },
  P_CSC: { level: 'P', charge: 'A', statusName: '진행중', pay: '-', desc: '심사일정결정완료' },
  P_CBT: { level: 'P', charge: 'O', statusName: '진행중', pay: '-', desc: '심사원,심사일정결정완료' },
  P_CFE: { level: 'P', charge: 'A', statusName: '진행중', pay: '-', desc: '심사계획완료' },
  P_RAP: { level: 'P', charge: 'D', statusName: '진행중', pay: '-', desc: '심사계획승인대기' },
  P_APR: { level: 'P', charge: 'O', statusName: '진행중', pay: '-', desc: '심사계획승인' },
  P_FER: { level: 'P', charge: 'C', statusName: '진행중', pay: '미납', desc: '수수료납부요청' },
  P_FEC: { level: 'P', charge: 'O', statusName: '진행중', pay: '입급확인요청', desc: '수수료납부확인대기' },
  P_FEA: { level: 'P', charge: 'A', statusName: '완료', pay: '납부완료', desc: '수수료납부확인' },

  J_RDY: { level: 'J', charge: 'J', statusName: '접수', pay: '-', desc: '공장심사 대기' },
  J_CHS: { level: 'J', charge: 'A', statusName: '접수', pay: '-', desc: '종류등급 수정' },
  J_WDR: { level: 'J', charge: 'A', statusName: '접수', pay: '-', desc: '심사철회 요청' },
  J_OVR: { level: 'J', charge: 'J', statusName: '진행중', pay: '-', desc: '공장현황작성완료' },
  J_EVA: { level: 'J', charge: 'J', statusName: '진행중', pay: '-', desc: '공장심사평가진행' },
  J_PRO: { level: 'J', charge: 'J', statusName: '진행중', pay: '-', desc: '공장심사중' },
  J_RPA: { level: 'J', charge: 'C', statusName: '진행중', pay: '-', desc: '공장심사 보고서작성 완료' },
  J_RPY: { level: 'J', charge: 'A', statusName: '적합', pay: '-', desc: '공장심사 보고서작성 업체확인(적합)' },
  J_RPN: { level: 'J', charge: 'J', statusName: '진행중', pay: '-', desc: '공장심사 보고서작성 업체확인(부적합)' },
  J_RPC: { level: 'J', charge: 'C', statusName: '진행중', pay: '-', desc: '부적합 보고서 작성완료' },
  J_RPK: { level: 'J', charge: 'A', statusName: '진행중', pay: '-', desc: '부적합 보고서 업체확인' }, // 이단계 건너뛰는것으로 바로 NFT로
  J_FIT: { level: 'J', charge: 'A', statusName: '적합', pay: '-', desc: '공장심사 보고서 적합상태' },
  J_NFT: { level: 'J', charge: 'J', statusName: '부적합', pay: '-', desc: '공장심사 보고서 부적합상태' },
  J_NRW: { level: 'J', charge: 'C', statusName: '부적합', pay: '-', desc: '부적합 개선조치보고서 등록대기' },
  J_NNR: { level: 'J', charge: 'J', statusName: '부적합', pay: '-', desc: '부적합 개선조치보고서 등록' },
  J_NNS: { level: 'J', charge: 'J', statusName: '부적합', pay: '-', desc: '부적합 개선조치보고서 검토' },
  J_NNI: { level: 'J', charge: 'C', statusName: '부적합', pay: '-', desc: '부적합 개선조치보고서 보완' },
  J_NNA: { level: 'J', charge: 'A', statusName: '적합', pay: '-', desc: '일반품질 부적합 개선조치보고서 적합' },
  J_NNC: { level: 'J', charge: 'A', statusName: '부적합', pay: '-', desc: '일반품질 부적합 개선조치보고서 확인심사' },
  J_NCR: { level: 'J', charge: 'A', statusName: '부적합', pay: '-', desc: '핵심품질 부적합 개선조치보고서 확인' },

  J_CFT: { level: 'J', charge: 'A', statusName: '적합', pay: '-', desc: '확인심사 적합' },
  J_CNF: { level: 'J', charge: 'A', statusName: '부적합', pay: '-', desc: '확인심사 부적합' },

  J_END: { level: 'J', charge: 'A', statusName: '적합', pay: '-', desc: '공장심사단계로 이동' },

  C_RDY: { level: 'C', charge: 'A', statusName: '접수', pay: '-', desc: '심의준비단계' },
  C_PRO: { level: 'C', charge: 'A', statusName: '진행중', pay: '-', desc: '인증평가 보고서 작성' },

  F_NFT: { level: 'F', charge: 'A', statusName: '부적합', pay: '-', desc: '심의 부적합' },
  F_NFA: { level: 'F', charge: 'A', statusName: '부적합', pay: '-', desc: '심의 부적합 통보' },
  F_FIT: { level: 'F', charge: 'A', statusName: '적합', pay: '-', desc: '심의 적합' },
  F_CRT: { level: 'F', charge: 'A', statusName: '인증번호부여', pay: '-', desc: '인증번호부여' },
  F_CON: { level: 'F', charge: 'C', statusName: '계약진행', pay: '-', desc: '합격통보 계약서 확인요청' },
  F_CAG: { level: 'F', charge: 'A', statusName: '계약완료', pay: '-', desc: '계약동의' },
  F_FIN: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '발급' },

  F_RS1: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '인증서 발급 승인' },
  F_RS2: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '합격통보' },
  F_RES: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '인증서 발급 완료' },

  F_MN1: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '인증서 유지 승인' },
  F_MN2: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '합격통보' },
  F_MAN: { level: 'F', charge: '-', statusName: '발급', pay: '-', desc: '인증서 유지 완료' },
};

// N:정기심사요청 ,A: 심사신청, P: 심사준비, J: 심사, C: 위원회심의, F: 심의후처리



// WEBPACK FOOTER //
// ./src/constants/status.js